import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tag, Divider, Tooltip, Avatar, Button } from 'antd';
import { EditOutlined, FileImageOutlined, FacebookOutlined, InstagramOutlined, ChromeOutlined, QrcodeOutlined } from '@ant-design/icons';
import StarRatings from 'react-star-ratings';
import { Grid, Row, Col } from 'react-flexbox-grid';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QRCode from "react-qr-code";
import './styles.css';

import repartiendoImage from '../../images/Repartiendo.svg';
import imageReservando from './../../images/ic_launcher.png';
import logo_reservando_word from './../../images/logo_reservando_word.png';
import templateQR from './../../images/templateQR.png';

const ProfileResto = ({ restaurant, fileListProfile, fileListSlider, onEditProfile, onEditImages, rangePrice, onDeepLinkClick, onRepartiendoDeepLinkClick }) => {
    const setAddress = () =>{
        return (
            <div>
                {(restaurant.address.street !== "" || restaurant.address.city !== "") && <h3>{restaurant.address.street}. {restaurant.address.city} ({restaurant.address.province} - {restaurant.address.country}) CP: {restaurant.address.postalCodeV2}</h3>}
                {restaurant.address.neighborhood !== "" && <h3>Barrio: {restaurant.address.neighborhood}</h3>}
            </div>
        );
    }

    const setNearCities = () => {
        return (
            <div>
                {
                    Object.keys(restaurant.nearCities).map(nearCity => {
                        var city = nearCity.split('_')
                        if(city.length === 3) {
                            return(<span key={nearCity}><li type="disc" style={{ marginLeft: '14px' }}><h3>{city[2]}</h3></li></span>)
                        } else {
                            return null
                        }
                    })
                }
            </div>
        )
    }

    const loadImage = url => {
        return new Promise((resolve) => {
          let img = new Image();
          img.onload = () => resolve(img);
          img.src = url;
        })
    }

    const handleDownloadQRResto = () => {
        const input = document.getElementById('templateQRGenerator');
        html2canvas(input, { scale: 2 })
        .then((canvas) => {
            loadImage(templateQR).then((template) => {
                const doc = new jsPDF('l');
                doc.addImage(template, 'PNG', 0, 0, 297, 210);
                const contentDataURL = canvas.toDataURL('image/png');
                doc.addImage(contentDataURL, 'PNG', 124, 25, 55, 55);
                /*heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(contentDataURL, 'PNG', margin, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }*/
                doc.save(`Reservando_QR_${restaurant.name}.pdf`);
            });
        });
    }

    return (
        <Grid className="profileRestoCont">
            <br />
            <Row center="xs">
                <Col xs={12}>
                    <Button icon={<QrcodeOutlined />} onClick={handleDownloadQRResto}>Descargar QR para asistencias</Button>
                </Col>
            </Row>
            <Row center="md">
                <Col xs={12} sm={12} md={8}>
                    <Card
                    title={
                        <div>
                            <span><Avatar size={64} src={fileListProfile.length > 0 ? fileListProfile[0].url : imageReservando} /> {restaurant.name}</span>
                            {
                                (restaurant.ratingAmbientTotal !== undefined && restaurant.ratingFoodTotal !== undefined && restaurant.ratingServiceTotal !== undefined && restaurant.ratingCount !== undefined) &&
                                <Grid>
                                    <br />
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={4}>
                                            <span>Comida: <StarRatings rating={(restaurant.ratingFoodTotal / restaurant.ratingCount)} starRatedColor="#94509b" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={4}>
                                            <span>Servicio: <StarRatings rating={(restaurant.ratingServiceTotal / restaurant.ratingCount)} starRatedColor="#7078b8" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={4}>
                                            <span>Ambiente: <StarRatings rating={(restaurant.ratingAmbientTotal / restaurant.ratingCount)} starRatedColor="#3383FF" starEmptyColor="#868686" starDimension="25px" starSpacing="1px"/></span>
                                        </Col>
                                    </Row>
                                </Grid>}
                        </div>
                    }
                    actions={[<Tooltip placement="top" title={"Editar perfíl"}><EditOutlined onClick={onEditProfile}/></Tooltip>, 
                    <Tooltip placement="top" title={"Editar imágenes"}><FileImageOutlined onClick={onEditImages}/></Tooltip>]}>
                        <Row start="xs">
                            <Col xs={12}>
                                { restaurant.phone && <h3>Telefono: {restaurant.phone}</h3>}
                            </Col>
                        </Row>
                        <Row start="xs">
                            <Col xs={12}>
                                <h3>Link para redes sociales:</h3>
                            </Col>
                        </Row>
                        <Row start="xs" middle="xs">
                            <Col xs={12}>
                                <Tooltip placement="top" title={"Copiar"}>
                                    <h3 onClick={onDeepLinkClick} style={{ color: '#7078b8' }}>{restaurant.deepLink}</h3>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Divider>Dirección</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                { restaurant.address ?
                                    setAddress()
                                    : ""
                                }
                            </Col>
                        </Row>
                        <Divider>Ciudades de cercanía</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                { restaurant.nearCities ?
                                    setNearCities()
                                    : ""
                                }
                            </Col>
                        </Row>
                        <Divider>Sitios</Divider>
                        <Row start="md">
                            <Col md={12}>
                                { restaurant.facebook && <h3><FacebookOutlined /> {restaurant.facebook}</h3>}
                            </Col>
                            <Col md={12}>
                                { restaurant.instagram && <h3><InstagramOutlined /> {restaurant.instagram}</h3>}
                            </Col>
                            <Col md={12}>
                                { restaurant.website && <h3><ChromeOutlined /> {restaurant.website}</h3>}
                            </Col>
                            <Col md={12}>
                                { restaurant.repartiendoDeepLink && <h3 className="repartiendoDeepLink" onClick={onRepartiendoDeepLinkClick}><img className="repartiendoImage" src={repartiendoImage}/> {restaurant.repartiendoDeepLink}</h3>}
                            </Col>
                        </Row>
                        <Divider>Precio del cubierto</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                { restaurant.price && <h3>{rangePrice[restaurant.price]}</h3>}
                            </Col>
                        </Row>
                        <Divider>Hitos geográficos</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                {restaurant.address && restaurant.address.hitos ? 
                                    restaurant.address.hitos.map(hito => <Tag key={hito}>{hito}</Tag>)
                                    : ""}
                            </Col>
                        </Row>
                        <Divider>Estilos</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                {restaurant.styles ? 
                                    restaurant.styles.map(style => <Tag key={style}>{style}</Tag>)
                                    : ""}
                            </Col>
                        </Row>
                        <Divider>Tipos</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                {restaurant.types ? 
                                    restaurant.types.map(type => <Tag key={type}>{type}</Tag>)
                                    : ""}
                            </Col>
                        </Row>
                        <Divider>Servicios</Divider>
                        <Row start="xs">
                            <Col xs={12}>
                                {restaurant.services ? 
                                    restaurant.services.map(service => <Tag key={service}>{service}</Tag>)
                                    : ""}
                            </Col>
                        </Row>
                        <Divider />
                        {restaurant.accessPeopleWithDisabilities && <h3>Acceso para personas con discapacidad</h3>}
                        {restaurant.advertising && <h3>Restaurante sólo para publicidad</h3>}
                    </Card>
                </Col>
            </Row>
            <div className="letterQR">
                <img className="templateQRCont" src={templateQR} alt="Plantilla QR Reservando"/>
                <div id="templateQRGenerator" className="qrCont">
                    <QRCode value={restaurant.id} size="207"/>
                </div>
            </div>
            <br />
        </Grid>
    );
};

ProfileResto.propTypes = {
    restaurant: PropTypes.object.isRequired,
    onEditProfile: PropTypes.func.isRequired,
    onEditImages: PropTypes.func.isRequired,
    rangePrice: PropTypes.object.isRequired,
};

export default ProfileResto;